import { atom } from 'jotai';

export const matchEventsAtom = atom([]);
matchEventsAtom.debugLabel = 'matchEvents';

export default { matchEventsAtom };
